import React from 'react';
import ReactDOM from 'react-dom/client';
import PricingCalculator from './App';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><PricingCalculator /></React.StrictMode>);
